export default __webpack_public_path__ + "static/core2r-1d59e6e04c356597818c4e13d694fc43.jpg";